module.exports = __webpack_public_path__ + "media/images/banner-assets/th/banner2-7eb0e2fd0233397f93c74acb3e7be1b6.jpg";